import React, { Component } from 'react'
import RestaurantList from '../restaurants/RestaurantList'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { addFavorite2, setDistanceList, updateSortOptions } from '../../store/actions/restaurantActions'
import Checkbox from '../layout/Checkbox'
import Select from 'react-select';
import { tagFunctions } from '../restaurants/Tags'
import { hoursFunctions } from '../restaurants/Hours'
import firebase from '../../config/fbConfig'

class Dashboard extends Component {

  constructor (props){
    super(props);
    this.state = {
        }
  }



  componentDidMount(props) {
    console.log('bot dashboard');
  }


  componentDidUpdate(){
    if (!this.props.auth.uid) return <Redirect to='/signin' />

    if(true){
      // this.setState({doFirst:true})
      console.log('trying doc data');
      const ref = firebase.firestore().collection('restaurants').doc('DDBatYILn6yEcqKSVR1W');  
      ref.get().then((doc) => {
        if (doc.exists) {
          console.log('doc data');
          console.log(doc.data());
        }
      })
    }

  }

  

  render() {
    const { auth, user } = this.props;
    if (!auth.uid) return <Redirect to='/signin' />
    
    //var restString = JSON.stringify(restaurants);
    var restString = 'test';

    return (
        <div>
      { auth && (user || auth.isAnonymous) &&
        <div>
          <p>{restString}</p>
        </div>
      }
      </div>
    )
  }
}


const mapStateToProps = (state) => {
  const user = state.firestore.data.users
                && state.firestore.data.users[state.firebase.auth.uid]
  return {
    auth: state.firebase.auth,
    user
  }
}

const mapDispatchToProps = dispatch => {
  return {
    addFavorite2: (project) => dispatch(addFavorite2(project)),
    setDistanceList: (distanceList, user) => dispatch(setDistanceList(distanceList, user)),
    updateSortOptions: (state) => dispatch(updateSortOptions(state))
  }
}

export default connect(mapStateToProps,mapDispatchToProps)(Dashboard)